import { countryCodes } from "./countryCodes";
export const Input = ({
  label,
  id,
  inputRef,
  onInputChange,
  error,
  placeholder,
  disable = false,
  forAuth,
  inputvalue,
  phone,
  className, name, onKeyDown, mZero=false, classes = "", maxLength
}) => {

  return (
    <div className={`${mZero ? "mb-0":"mb-3"} w-full`}>
      {label && <label
        htmlFor={id}
        className="block mb-1 text-primary text-f14 font-semibold text-left"
      >
        {label}
      </label>}
      <input
        type="text"
        id={id}
        ref={inputRef}
        name={name}
        onChange={onInputChange}
        value={inputvalue}
        placeholder={placeholder}
        disabled={disable}
        onKeyDown={onKeyDown}
        maxLength={maxLength}
        className={classes ? classes : `w-full border 
        ${phone ? 'pl-[116px]' : ''}
        ${forAuth == 'authInput' ? 'pl-[120px]' : 'px-3'}  
        ${error ? "border-red-500" : "border-input"} focus:border-primary  py-2 border-input rounded 
        ${disable ? "bg-inputDisable" : "bg-input"}
        `+ " " + className}
      />
      {error && <p className="text-red-500 text-sm text-left ">{error}</p>}
    </div>
  );
};
